import { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Helmet } from 'react-helmet-async';

import PageBuilder from '../../Components/PageBuilder/PageBuilder';
import VideoBanner from '../../Components/VideoBanner/VideoBanner';
import PageLoader from '../../common/PageLoader/PageLoader';
import { useDataContext } from '../../core/context/data.context';
import { useUserContext } from '../../core/context/user.context';
import PageNotFound from '../PageNotFound/PageNotFound';

function Home() {
  const { user } = useUserContext();
  const [slug, setSlug] = useState('');

  const hasCustomLandingHome = Boolean(user?.user_groups?.[0]?.landingHomeSlug);
  const shouldRedirectToPlayground = Boolean(user.email) && !hasCustomLandingHome;

  const modalContainer: HTMLElement | null = document.getElementById('modal');
  const {
    data: { [slug]: page, generalData },
    setPage,
  } = useDataContext();
  const body = useMemo(() => page || null, [page]);

  useEffect(() => {
    if (!shouldRedirectToPlayground) return;
    window.location.replace(`/pg${window.location.search}`);
  }, [shouldRedirectToPlayground]);

  useEffect(() => {
    setSlug(
      !user.token || (user && !user?.user_groups?.[0]?.landingHomeSlug)
        ? 'world-home-page'
        : user.user_groups?.[0].landingHomeSlug || '',
    );
  }, [setSlug, user]);

  useEffect(() => {
    if (!slug) return;
    setPage(slug);
  }, [setPage, slug]);

  if (shouldRedirectToPlayground) return null;
  if (!slug) return null;

  return (
    <>
      <Helmet>
        {!page?.seo?.title && !generalData?.seo?.title ? null : (
          <title>{page?.seo?.title || generalData?.seo?.title}</title>
        )}
        {!page?.seo?.canonical ? null : <link rel="canonical" href={page?.seo?.canonical} />}
        {!page?.seo?.description && !generalData?.seo?.description ? null : (
          <meta
            name="description"
            content={page?.seo?.description || generalData?.seo?.description}
          />
        )}
      </Helmet>
      {!modalContainer ? null : createPortal(<PageLoader open={!body} />, modalContainer)}
      {!body ? null : body === 'Page not found' ? (
        <PageNotFound />
      ) : (
        <>
          <VideoBanner key={user?._id} />
          {/* {!body.banner ? null : <HomeBanner {...body.banner} />} */}
          {/* {!body.pageBanner || body.type === 'simple' ? null : <HomeBanner {...body.pageBanner} />} */}
          {!body.pageBuilder ? null : <PageBuilder data={body.pageBuilder} slug="home-page" />}
        </>
      )}
    </>
  );
}

export default Home;
